import {createContext} from 'react';
import {Client} from '@stomp/stompjs';

export type WebSocketContextType = {
  client?: Client;
  connected: boolean;
};
export const WebSocketContext = createContext<WebSocketContextType>({client: undefined, connected: false});
